// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp-box {
    width: 320px;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    text-align: center;
}

.otp-box h2 {
    margin-bottom: 20px;
    font-size: 27px;
}

.otp-form {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    direction: ltr;
}

.otp-input {
    width: 50px;
    height: 50px;
    text-align: center;
    font-size: 18px;
    border-radius: 4px;
    border: 1px solid #ddd;
    outline: none;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.submit-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    border: none;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
}

.timer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    font-size: 20px;
    color: #555;
}

.timer-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 40px;
    border-radius: 4px;
    background-color: var(--secondary-color);
    border: none;
    color: var(--primary-color);
    font-size: 16px;
}

.resend-btn {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    background-color: var(--secondary-color);
    border: none;
    color: var(--primary-color);
    font-size: 16px;
    cursor: pointer;
}

.resend-btn.disabled {
    color: #ccc;
    cursor: not-allowed;
}

.resend-btn:hover {
    background-color: var(--secondary-hover);
    color: black;
}`, "",{"version":3,"sources":["webpack://./src/pages/CheckOTP/CheckOTP.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,YAAY;AAChB","sourcesContent":[".otp-box {\n    width: 320px;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    background-color: #fff;\n    text-align: center;\n}\n\n.otp-box h2 {\n    margin-bottom: 20px;\n    font-size: 27px;\n}\n\n.otp-form {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    direction: ltr;\n}\n\n.otp-input {\n    width: 50px;\n    height: 50px;\n    text-align: center;\n    font-size: 18px;\n    border-radius: 4px;\n    border: 1px solid #ddd;\n    outline: none;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.submit-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 10px;\n    border-radius: 4px;\n    border: none;\n    color: #fff;\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.timer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 15px;\n    font-size: 20px;\n    color: #555;\n}\n\n.timer-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100px;\n    height: 40px;\n    border-radius: 4px;\n    background-color: var(--secondary-color);\n    border: none;\n    color: var(--primary-color);\n    font-size: 16px;\n}\n\n.resend-btn {\n    width: 100px;\n    height: 40px;\n    border-radius: 4px;\n    background-color: var(--secondary-color);\n    border: none;\n    color: var(--primary-color);\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.resend-btn.disabled {\n    color: #ccc;\n    cursor: not-allowed;\n}\n\n.resend-btn:hover {\n    background-color: var(--secondary-hover);\n    color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
